var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmarkFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M17.469 1c.681 0 1.359.229 1.878.67l.186.177c.414.43.667.996.667 1.612V22.08a.908.908 0 0 1-1.496.692L12 17.065l-6.704 5.706a.907.907 0 0 1-1.496-.69V3.458c0-.704.33-1.342.854-1.788l.2-.155A2.94 2.94 0 0 1 6.53 1z"
})));
export default SvgBookmarkFill;